module.exports = __webpack_public_path__ + "static/media/spinner.695888b4.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/console/images/spinner.gif
// module id = 1939
// module chunks = 0